// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"i8","image":"i9","contentContainer":"i-","mainText":"i_","subText":"ja","counter":"jb"};